"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _RightActionsSection = require("./RightActionsSection");
Object.keys(_RightActionsSection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RightActionsSection[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _RightActionsSection[key];
    }
  });
});
